import React, { FC } from 'react';
import { UserRow } from '../types';
import {
    DefaultCell,
    IconButton,
    IconButtonSizes,
    IconButtonStyles,
    Icons,
    TwoLinesCell
} from '@silverfort/sf-components';
import InvestigationDrawer from '../../../../InvestigationDrawer/InvestigationDrawer';
import { useAppDrawer } from '../../../../AppDrawer/AppDrawerProvider';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';

type Props = UserRow;

const NameCell: FC<Props> = ({ id, name }) => {
    const { displayContent } = useAppDrawer();

    const handleInvestigationClick = () => {
        displayContent(<InvestigationDrawer guid={id} adType={AD_ENTITY_TYPES.USER} />);
    };

    if (name.userName) {
        return (
            <TwoLinesCell
                topText={name.fullName}
                bottomText={name.userName}
                trend={(name.secondaryUsersCount ? `(${name.secondaryUsersCount} users)` : undefined)}

                rightElement={
                    <IconButton
                        className="opacity-0 group-hover:opacity-100"
                        sizeVariant={IconButtonSizes.Large}
                        buttonStyle={IconButtonStyles.Secondary}
                        iconSize={20}
                        icon={Icons.Investigate}
                        onClick={handleInvestigationClick}               
                    />
                }
            />
        );
    }
    return (
        <div className="flex items-center">
            <DefaultCell text={name.fullName} />
            <IconButton
                className="opacity-0 group-hover:opacity-100"
                sizeVariant={IconButtonSizes.Large}
                buttonStyle={IconButtonStyles.Secondary}
                iconSize={20}
                icon={Icons.Investigate}
                onClick={handleInvestigationClick}
            />
        </div>
    );
};

export default NameCell;
